import { LocationRestrictionEnum } from '@nida-web/shared/utils';

export class Group {
  id?: number;
  groupName?: string;
  groupDescription?: string;
  idMandanten?: number;
  groupMapping?: string;
  station?: string;
  idPosition?: number;
  locationRestrictions?: LocationRestrictionEnum[];

  constructor(
    id?: number,
    idMandanten?: number,
    groupName?: string,
    groupDescription?: string,
    groupMapping?: string,
    station?: string,
    idPosition?: number,
    locationRestrictions?: LocationRestrictionEnum[]
  ) {
    this.id = id || 0;
    this.idMandanten = idMandanten || 0;
    this.groupName = groupName || '';
    this.groupDescription = groupDescription || '';
    this.groupMapping = groupMapping || '';
    this.station = station || '';
    this.idPosition = idPosition || 0;
    this.locationRestrictions = locationRestrictions || [];
  }
}
